import { Trans } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { useStore } from 'zens-store'
import { Color, Text, TextProps } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    color: Color.graphiteGrey,
  },
})

interface Props extends TextProps {}

const HomeWelcome = (props: Props) => {
  const { style, ...otherProps } = props
  const { auth } = useStore()
  const name = auth.profile?.displayName
  return (
    <Text level={3} style={[styles.container, style]} {...otherProps}>
      <Trans>Welcome, {{ name }}</Trans>
    </Text>
  )
}

export default HomeWelcome
